<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Active Redemptions</v-toolbar-title>
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">

      <v-tabs
        v-model="tab"
        color="primary"
        slider-color="primary"
      >
        <v-tab>Customers</v-tab>
<!--        Not supported in Stripe API yet-->
<!--        <v-tab :key="2">Subscriptions</v-tab>-->

      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <base-stripe-table
            :headers="headers"
            :fetch-action="'listCustomers'"
            :fetch-query="{ coupon: $route.params.id }"
            :items-getter="'getCustomers'"
            :pagination-getter="'getCustomerPagination'"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  @click="goto(item.id)"
                >
                  <td>{{ item.name }} ({{ item.email }})</td>
                  <td>{{ item.description }}</td>
                  <td>{{ customerSource(item) }}</td>
                  <td>{{ _formatDate(item.created) }}</td>
                </tr>
              </tbody>
            </template>
          </base-stripe-table>

        </v-tab-item>
<!--        <v-tab-item :key="2">-->
<!--          <base-stripe-table-->
<!--            :headers="headers"-->
<!--            :fetch-action="'listSubscriptions'"-->
<!--            :fetch-query="{-->
<!--              coupon: $route.params.id,-->
<!--              expand: [ 'data.customer', 'data.items.data.plan' ]-->
<!--            }"-->
<!--            :items-getter="'getCustomers'"-->
<!--            :pagination-getter="'getCustomerPagination'"-->
<!--          >-->
<!--            <template v-slot:body="{ items }">-->
<!--              <tbody>-->
<!--                <tr-->
<!--                  v-for="item in items"-->
<!--                  :key="item.id"-->
<!--                  @click="goto(item.id)"-->
<!--                >-->
<!--                  <td>{{ item.name }} ({{ item.email }})</td>-->
<!--                  <td>{{ item.description }}</td>-->
<!--                  <td></td>-->
<!--                  <td>{{ _formatDate(item.created) }}</td>-->
<!--                </tr>-->
<!--              </tbody>-->
<!--            </template>-->
<!--          </base-stripe-table>-->
<!--        </v-tab-item>-->
      </v-tabs-items>


    </v-card-text>
  </v-card>
</template>
<script>
import BaseStripeTable from "../Common/BaseStripeTable"
import { get, isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import { formatDate, formatMoney } from "../../services/util.service"
import { getDefaultSourceFromCustomer } from '@/services/stripe.service'

export default {
  components: {
    BaseStripeTable
  },
  data() {
    return {
      tab: 0,
      model: {},
      isLoading: false,
      headers: [
        {
          text: 'Customer',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Description',
          sortable: false,
        },
        {
          text: 'Default Source',
          sortable: false
        },
        {
          text: 'Cust. Created',
          sortable: false
        },
      ]
    }
  },
  methods: {
    _formatMoney: ({ currency, amount }) => formatMoney({ currency, amount }),
    _formatDate: (date) => formatDate(date),
    customerSource(customer) {
      const source = getDefaultSourceFromCustomer(customer)

      return isEmpty(source)
        ? '--'
        : `${source.brand} ****${source.last4}`
    },
    goto() {

    }
  }
}
</script>
